export interface AppState {
	example_dontRemove: ''
}

export const app: AppState = {
	example_dontRemove: '',
}
